import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import popupDrag from '../../static/image/popup_drag.png';
import '../../static/css/popup.css';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const MenuGroupDrag = (props) => {
  const [items, setItems] = useState(props.items);
  const reset = props.reset;

  useEffect(() => {
    items.sort(function(a, b) {
      return parseFloat(a.displayOrder) - parseFloat(b.displayOrder);
    });
  }, [reset]);

  useEffect(() => {
    const closeBtnClickHandler = () => {
      $('.menuGrpPopup2').addClass('hide');
    };

    var items = props.items;
    setItems(items);

    $('.menuGrpPopup2closeBtn').off('click').on('click', closeBtnClickHandler);

    return () => {
      // Clean up the event handler when component unmounts
      $('.menuGrpPopup2closeBtn').off('click', closeBtnClickHandler);
    };
  }, [props.items]);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const updatedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    setItems(updatedItems);
  };

  const listNumber = items.map((value, index) => (
    <li key={index}>{index + 1}</li>
  ));

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <ul className='dragNumberBox'>{listNumber}</ul>
      <Droppable droppableId="menuGrpDragBox">
        {(provided, snapshot) => (
          <ul
            className='popupDrag'
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {items.map((item, index) => (
              <Draggable
                key={item.id}
                draggableId={`item-${item.id}`}
                index={index}
              >
                {(provided, snapshot) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <img
                      className='popupDragImg'
                      src={popupDrag}
                      alt="팝업드래그"
                    />
                    <div>
                      <p
                        className="popupDragTitle popupMenuGrpDragTitle"
                        data-id={item.id}
                      >
                        {item.name}
                      </p>
                    </div>
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default MenuGroupDrag;
